import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import Fade from '@mui/material/Fade';
const easeOut = 'cubic-bezier(0.23, 1, 0.32, 1)';
const PortalFade = forwardRef(function PortalFade(props, ref) {
    return _jsx(Fade, { easing: { enter: easeOut, exit: easeOut }, ...props, ref: ref });
});
export function pressFeedback(theme, quietMotion) {
    return {
        transition: quietMotion ? 'none' : theme.transitions.create(['background-color', 'border-color', 'box-shadow', 'transform'], { duration: 120, easing: easeOut }),
        '@media (hover: hover) and (pointer: fine)': {
            '&:active:not(.Mui-disabled):not(.Mui-focusVisible):not(:focus-visible)': {
                transform: quietMotion ? 'none' : 'scale(0.98)',
            },
        },
        '&.Mui-focusVisible, &:focus-visible': {
            transition: 'none',
        },
        '&.Mui-disabled': { transition: 'none' },
        '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
            '&:active': { transform: 'none' },
        },
    };
}
/** Defaults only: retain MUI portals, focus handling and explicit caller props. */
export function interaction(theme, quietMotion) {
    return {
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    '&.Mui-focusVisible:not(.Mui-disabled), &:focus-visible:not(.Mui-disabled)': {
                        outline: `2px solid ${theme.palette.primary.dark}`,
                        outlineOffset: 3,
                    },
                    ...(quietMotion && { '& .MuiTouchRipple-root': { display: 'none' } }),
                    '@media (prefers-reduced-motion: reduce)': {
                        '& .MuiTouchRipple-root': { display: 'none' },
                    },
                    '@media (forced-colors: active)': {
                        '&.Mui-focusVisible, &:focus-visible': { outlineColor: 'Highlight' },
                    },
                },
            },
        },
        MuiButton: {
            defaultProps: { disableFocusRipple: true },
        },
        MuiIconButton: {
            defaultProps: { disableFocusRipple: true },
            styleOverrides: { root: pressFeedback(theme, quietMotion) },
        },
        MuiDialog: {
            defaultProps: { TransitionComponent: PortalFade, transitionDuration: quietMotion ? 0 : { enter: 180, exit: 120 } },
        },
        MuiMenu: {
            defaultProps: { TransitionComponent: PortalFade, transitionDuration: quietMotion ? 0 : 160 },
        },
        MuiPopover: {
            defaultProps: { TransitionComponent: PortalFade, transitionDuration: quietMotion ? 0 : 160 },
        },
    };
}
